// extracted by mini-css-extract-plugin
export var compactFilters = "_et-4";
export var detailImage = "_et-1";
export var dropdownContainer = "_et-2";
export var imageContainer = "_et-0";
export var selectedCard = "_et-3";